import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'app/shared/auth/auth.service';
import { AlreadyEnrolledComponent } from 'app/shared/components/already-enrolled/already-enrolled.component';
import { User } from 'app/shared/models/user.model';
import { PopupModalComponent } from 'app/shared/popup-modal/popup-modal.component';
import { ApiService } from 'app/shared/services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import swal from 'sweetalert2';

@Component({
  selector: 'app-connect-to-learn',
  templateUrl: './connect-to-learn.component.html',
  styleUrls: ['./connect-to-learn.component.scss']
})
export class ConnectToLearnComponent implements OnInit {
  selectedTag:string[]=[];
  activatedUser: User;
  selectedCategory=null;
  categoryList=[];
  courseList=[];
  tagsList=[];
  emailPhoneValid:boolean = true;
  phoneAlreadyExist:boolean = false
  emailAlreadyExist:boolean = false
  enrolmentModel={
    name:'',
    email:'',
    phone:'',
    college:'',
    coursecatinterest_id:'',
    skillsinterest_id: '',
    last_qualification:'',
    qualification_year:''
  }
  catId='6319d5025ab9e462a96cfbba'
  skillId='6319d3595ab9e462a96cfb06'
  collegeList=[];
  selectedCollege=null
  public user={
    p1:'college',
    p2:'batch'
  }
  subscribeUser: Subscription;
  emailCheck = new FormControl(Validators.required,Validators.email);
  phoneCheck = new FormControl('',Validators.required)
  businessTypeCompany_Id=''
  businessTypeCollege_Id='6325cdefbc4b543c7a2429a4'
  emailExistError: boolean = false;
  reflink_id:any
  current_user:any
  redirectURL = ''
  check_user:any
  isLogin_otp_step : boolean = false
  login_otp_data:any
  login_otp:any
  login_token:any
  user_role :any
  login_otp_to_phn:any
  login_otp_to_email:any
  event_type_list=[]
  selected_type = null
  tag_cat_id:any
  years_list=[]
  selected_year=null
  constructor(private router: Router,
              private apiService:ApiService,
              public toastr: ToastrService,
              private modalService: NgbModal,
              private auths: AuthService,
              private spinner: NgxSpinnerService, private authService: AuthService,
              private ref: ChangeDetectorRef,private route: ActivatedRoute
              ) {
                this.activatedUser = auths.userValue;
                this.subscribeUser = this.auths.userChanges.subscribe(res => {
                  this.activatedUser = res;
                  if(this.activatedUser!==null){
                   this.enrolmentModel.name = this.activatedUser.name;
                   this.enrolmentModel.email = this.activatedUser.email;
                   this.enrolmentModel.phone = this.activatedUser.phone;
                   this.enrolmentModel.college = this.activatedUser?.college
                  }
                });  
                this.getAllCollege()
                this.getTagCatList()
                this.getTagByCategory()
                this.getSkillTagByCategory()
    }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      this.reflink_id = params.get('ref');
    });
    this.getYears()
  }
 
  getAllCollege(){
    this.apiService.getBusinessByTypeId(this.businessTypeCollege_Id).subscribe((res:any)=>{
      this.collegeList=res.data
    })
  }
  getCollegeId(event:any){
    this.selectedCollege
  }
  getTagByCategory(){
    this.apiService.getTagByTagCatgoryId(this.catId).subscribe((res:any)=>{
      this.categoryList=res.data
    })
   }
   getSkillTagByCategory(){
    this.apiService.getTagByTagCatgoryId(this.skillId).subscribe((res:any)=>{
      this.tagsList=res.data
    })
   }
   getCategoryId(event:any){
    this.selectedCategory
   }
  getTagsId(event:any){
    this.selectedTag
  }
  submit(){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    var body={
      name:this.enrolmentModel.name,
      email:this.enrolmentModel.email,
      phone:this.enrolmentModel.phone,
      college:this.selectedCollege,
      coursecatinterest_id: this.selectedCategory?this.selectedCategory :'6319d6035ab9e462a96cfc53',
      skillsinterest_id: [],
      refrence_id : this.reflink_id ? this.reflink_id :'',
      event_type : this.selected_type,
      last_qualification: this.enrolmentModel.last_qualification,
      qualification_year : this.selected_year
    }
    if(this.selectedTag){
      body.skillsinterest_id = this.selectedTag
    }
    else{
      body.skillsinterest_id = ['6319d3e55ab9e462a96cfb30']
    }
      this.apiService.createEnrolment(body).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.spinner.hide()    
          this.toastr.success(res.message)  
          this.sendMail(res?.data?.email)
          swal.fire({
            title: "Success!",
            text: `${this.enrolmentModel.name} you are successfully enrolled now!`,
            icon: "success",
            customClass: {
              confirmButton: 'btn btn-primary'
            },
            buttonsStyling: false,
          });

          let n = res?.data?.name.substring(0, 4).toUpperCase();
          let p = res?.data?.phone.substring(6)
          let log_detail = {
            email:res?.data?.email,
            password: n+p
          }
          this.login(log_detail,'landing')
        }
        else{
          this.spinner.hide()
        }
      })
    
  }
  login(login_detail,url){
    this.authService.signinUser(login_detail,url)
    .subscribe((res: any) => {

      console.log('res',res)
      console.log('user',this.user)
      console.log('check_user',this.check_user)
      if (res.isSuccess == true ) {
        console.log('✅ Login successful - checking route conditions...')
        console.log('user_role:', this.user_role, 'check_user:', this.check_user)
        
        if(this.check_user === true){
          console.log('🔄 Route condition 1: check_user is true - navigating to /profile')
          setTimeout(() => {
            this.router.navigate(['/profile'])
          }, 1000);
        }
        else if(this.check_user === false){
          console.log('🔄 Route condition 2: check_user is false - navigating to /events')
          setTimeout(() => {
            this.router.navigate(['/events'])
          }, 1000);
        }
        else if(this.user_role ==='student'){
          console.log('🔄 Route condition 3: user_role is student - navigating to /profile')
          setTimeout(() => {
            this.router.navigate(['/profile'])
          }, 1000);
        }
        else if(this.user_role ==='admin' || this.user_role === 'employee' ){
          console.log('🔄 Route condition 4: user_role is admin or employee - navigating to /dashboard')
          setTimeout(() => {
            this.router.navigate(['/dashboard'])
          }, 1000);
        }
        else {
          console.log('⚠️ No route condition matched - user_role:', this.user_role, 'check_user:', this.check_user)
        }
      }
      else {
        console.log('❌ Login failed - showing error message')
        this.toastr.error(res.error)
      }
    });
  }

  openContent(data:any) {
    let number =data;
    const modalRef = this.modalService.open(PopupModalComponent);
    switch(number){
      case  1 : 
        modalRef.componentInstance.user = this.user.p1;
        modalRef.result.then((data) => {
          if(data=="success"){
            this.getAllCollege()
          }
          // on close
        }, (reason) => {
          // on dismiss
        });
      break;
      case 2:
        modalRef.componentInstance.user = this.user.p2;
      break;
    }
}
validateEmail (emailAdress){
  let regexEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  if (emailAdress.match(regexEmail)) {
    return true; 
  } else {
    return false; 
  }
 
}
openModal(){
    const modalRef = this.modalService.open(AlreadyEnrolledComponent);
}
checkEmailPhone(email,phone){
  let model={
    email:email,
    phone:phone,
  }
  this.apiService.checkIfAlreadyExist(model).subscribe((res:any)=>{
    if(res.statusCode === 200){
      // Convert string response to boolean
      this.check_user = res?.data === "User not found" ? false : true
      this.emailPhoneValid =true
      this.phoneAlreadyExist = false
      this.emailAlreadyExist = false
      if(res?.data === "Email and phone already exist"){
       this.isLogin_otp_step = true
       this.login_otp_data = 'Email'
       this.login_otp_to_email = this.obscureEmail(model.email)
       this.sendLoginOtp(model.email)
      }

      if(res?.data === 'Email already exists'){
       this.isLogin_otp_step = true
       this.login_otp_data = 'Email'
       this.login_otp_to_email = this.obscureEmail(model.email)
       this.sendLoginOtp(model.email)
      }

      if(res?.data === "Phone number already exists"){
        this.isLogin_otp_step = true
        this.login_otp_data = 'Phone'
        this.login_otp_to_phn = model.phone.substring(6)
       this.sendLoginOtp(model.phone)
      }
    }
 
})
}
sendMail(email){
  if(email){
    this.apiService.sendMail(email).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.toastr.success(res.message)
      }
      else{
        this.toastr.error(res.error)
      }
    })
  }
}
sendLoginOtp(data){
  if(this.login_otp_data === 'Email'){
    let body ={
      email: data
    }
    this.apiService.sendLoginOtp(body).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.login_token = res?.data?.token
        this.toastr.success(res?.message)
      }
      else this.toastr.error(res?.error)
    })
  }
  if(this.login_otp_data === 'Phone'){
    let body ={
      phone: data
    }
    this.apiService.sendLoginOtp(body).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.login_token = res?.data?.token
        this.toastr.success(res?.message)
      }
      else this.toastr.error(res?.error)
    })
  }

 
}

loginOtpVerify(){
  let body ={
      otp: this.login_otp,
      token: this.login_token
  }
  this.authService.loginOtpVerify(body).subscribe((res:any)=>{
    if(res?.statusCode === 200){
      this.toastr.success(res?.message)

      switch(res?.data?.roles){
        case 'student':
          this.router.navigate(['/profile'])
          break;
        case 'employee':
          this.router.navigate(['/dashboard'])
          break;
        case 'extractor':
          this.router.navigate(['/dashboard'])
          break;
        case 'admin':
          this.router.navigate(['/dashboard'])
          break;
      }
    }
    else this.toastr.error(res?.error)
  })
}

obscureEmail(email) {
  const parts = email.split('@');
  if (parts.length === 2) {
    const username = parts[0];
    const domain = parts[1];
    const obscuredUsername = username.slice(0, 3) + 'x'.repeat(username.length - 3);
    return obscuredUsername + '@' + domain;
  }
  return email;
}
getTagCatList() {
  this.apiService.getAllCategory(1, 100).subscribe((res: any) => {
    let cat = res?.data?.items.find((item) => item.name == "event_type");
    this.tag_cat_id = cat._id;
    if (this.tag_cat_id) {
      this.getTypeList(this.tag_cat_id);
    }
  });
}
getTypeList(id) {
  this.apiService.getTagByTagCatgoryId(id).subscribe((res: any) => {
    this.event_type_list = res.data;
  });
}
getTypeId(event) {
  this.selected_type;
}
getYears() {
  const currentYear = new Date().getFullYear();
  this.years_list = [];
  for (let year = currentYear; year >= 1900; year--) {
    this.years_list.push({year:year});
  }
  return this.years_list;
}
getYear(event){
  this.selected_year
}
}
